import { useState, useEffect } from 'react';
import { Layout, SignupForm, DownloadChecklistPdfForm } from '../../../components';
import Router from 'next/router';
import { NextSeo } from 'next-seo';
import facilityBotApi from '../../../services/facilityBot';
import { Spin, Typography } from 'antd';
const { Paragraph } = Typography;
import { ChecklistResponse } from '../../../response_schemas/checklists';
import { ApiError } from '../../../response_schemas/apiErrors';

export default function ChecklistLibrary() {
	const [showDetail, setShowDetail] = useState(false);
	const [detailItem, setDetailItem] = useState({});
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		let checklistId = Router.query.id;

		if (checklistId && checklistId.length) {
			setLoading(true);
			setShowDetail(true);

			facilityBotApi
				.get(`/clients/public_checklists/${checklistId}`)
				.then((res) => {
					const response = new ChecklistResponse(res);
					setDetailItem(response.checklist);
					setLoading(false);
				})
				.catch((err) => {
					const error = new ApiError(err);
					console.log('🚀 ~ file: [slug].js ~ line 27 ~ .then ~ err', error.errorMessage);
				});
		}
	}, []);

	const handleShowList = () => {
		setShowDetail(false);
		setDetailItem({});
		Router.push({ pathname: `/resources/checklist-library/`, query: undefined }, undefined, { shallow: true });
	};

	return (
		<Layout pageName="Checklist Library">
			<NextSeo title={`Facilities Management Checklist | ${detailItem.title}`} description={detailItem.notes} />
			<div className="resource-page resource-page--checklist-library">
				<section className="heading-container">
					<div className="container">
						<div className="heading">
							<h1 className="heading__title">Checklist Library</h1>
							<h2 className="heading__desc">Get started quickly with a checklist template</h2>
						</div>
					</div>
				</section>

				<section className="container checklists">
					<aside className="checklists__sidebar"></aside>

					<div className="checklists__content">
						{showDetail ? (
							<DetailChecklist checklist={detailItem} handleShowList={handleShowList} loading={loading} />
						) : (
							<div className="checklists__list">
								<div style={{ textAlign: 'center' }}>
									<Spin size="large"></Spin>
								</div>
							</div>
						)}
					</div>
				</section>
			</div>
		</Layout>
	);
}

const DetailChecklist = ({ checklist, handleShowList, loading }) => (
	<Spin spinning={loading} size="large">
		<div className="detail-checklist">
			<div className="detail-checklist__heading">
				<div className="detail-checklist__title-wrapper">
					<div className="detail-checklist__back-link" onClick={handleShowList}>
						Back to Search Results
					</div>
					<div className="detail-checklist__title">{checklist.title}</div>
					<div className="detail-checklist__desc">
						<Paragraph ellipsis={{ rows: 3, expandable: true, symbol: 'more' }}>{checklist.notes}</Paragraph>
					</div>
				</div>

				<div className="detail-checklist__btn-wrapper">
					<SignupForm
						btnText="Sign in & use in facilitybot"
						btnClass="btn btn--checklist"
						type={{ name: 'checklist', id: checklist.id }}
					/>

					<DownloadChecklistPdfForm classNameBtn="btn btn--checklist" checklist={checklist} />
				</div>
			</div>

			{checklist.pdf_data && (
				<div className="detail-checklist__review-pdf">
					<iframe
						src={`data:application/pdf;base64, ${checklist.pdf_data}#toolbar=0&navpanes=0&scrollbar=0`}
						className="detail-checklist__review-pdf"
						loading="lazy"
					/>
				</div>
			)}
		</div>
	</Spin>
);

export async function getServerSideProps() {
	try {
		return {
			props: {},
		};
	} catch (err) {
		console.error('🚀 ~ file: [slug].js ~ line 132 ~ getServerSideProps ~ err', err);

		return {
			notFound: true,
		};
	}
}
